export const PHRASE_INPUT = 'PHRASE_INPUT';
export const STARTING_PAGE = 'STARTING_PAGE';
export const TOKEN_SELECTION = 'TOKEN_SELECTION';
export const TOKEN = 'TOKEN';
export const TEXT = 'TEXT';
export const EDIT_TOKEN_SELECTION = 'EDIT_TOKEN_SELECTION';
